import * as React from 'react';
import {Fragment, useState} from 'react';
import Paper from '@mui/material/Paper';
import FormControl from "@mui/material/FormControl";
import {ButtonGroup, Grid, InputLabel} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CasinoOutlinedIcon from '@mui/icons-material/CasinoOutlined';
import AddIcon from '@mui/icons-material/Add';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {v4} from "uuid";
import {styled} from "@mui/material/styles";
import {ICharPresets} from "../../_interfaces/ICharPresets";
import {useSignals} from "@preact/signals-react/runtime";
import PresetsEdit from "./PresetsEdit";
import {s_char, s_char_matrices, s_char_presets, s_char_skills, s_char_talents} from "../../_signals/s_char";
import {CharacterFieldUpdateField} from "../../_payload/CharacterFieldUpdateField";
import updChar from "../../_sig_api/updChar";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {rollerOpen, rollerSetRoll} from "../../_helper/rollBehave";
import IconButton from "@mui/material/IconButton";
import {PresetsDelete} from "../../_api/BEPresets";
import {displayMod} from "../../_helper/displayMod";
import Skills from "../Skills/Skills";
import Talents from "../Talents/Talents";
import MatriceSpellWeaving from "../MatriceSpell/MatriceSpellWeaving";
import MatriceSpellCasting from "../MatriceSpell/MatriceSpellCasting";
import MatriceSpell from "../MatriceSpell/MatriceSpell";
import {s_app_mobile} from "../../_signals/s_app";
import AttributesDisplay from "../Attributes/AttributesDisplay";
import CharErholungsproben from "../Schaden/CharErholungsproben";
import Presets from "./Presets";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

const Item = styled('div')(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff', ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
}));


export default function Roll() {
    useSignals()
    const [what, setwhat] = useState('presets')

    return <>
        <Paper style={{marginTop:24,padding:4}}>
            <Stack direction="row" spacing={2} justifyContent= "space-between" useFlexGap flexWrap="wrap">
                <Button variant={what == 'presets' ? "contained" : "outlined"}
                        onClick={() => setwhat('presets')}>Eigene</Button>
                <Button variant={what == 'attributes' ? "contained" : "outlined"}
                        onClick={() => setwhat('attributes')}>Attribute</Button>
                <Button variant={what == 'erholung' ? "contained" : "outlined"}
                        onClick={() => setwhat('erholung')}>Erholung</Button>
                <Button variant={what == 'skills' ? "contained" : "outlined"}
                        onClick={() => setwhat('skills')}>Fertigkeiten</Button>
                <Button variant={what == 'talents' ? "contained" : "outlined"}
                        onClick={() => setwhat('talents')}>Talente</Button>
                <Button variant={what == 'spells' ? "contained" : "outlined"}
                        onClick={() => setwhat('spells')}>Sprüche</Button>
            </Stack>
        </Paper>
        {what == 'presets' && <Presets/>}
        {what == 'attributes' ? <AttributesDisplay/> : null}
        {what == 'erholung' ? <Paper style={{marginTop:8}}><CharErholungsproben/></Paper> : null}
        {what == 'skills' && s_char_skills.value.length > 0 ? <Skills roll={true}></Skills> : null}
        {what == 'talents' && s_char_talents.value.length > 0 ? <Talents roll={true}></Talents> : null}
        {what == 'spells' && s_char_matrices.value.length > 0 ? <MatriceSpell roll={true}></MatriceSpell> : null}
    </>

}
